import axios from 'axios';
import loadImage from 'blueimp-load-image/js';
import SettingIcon from '../assets/svgIcons/setting-2.svg';
import CampaignIcon from '../assets/svgIcons/megaphone.svg';
import NotificationIcon from '../assets/svgIcons/notification.svg';
import { wcaUploadProfilePicture } from '../reducers/wca/setting/setting.action';

const languageOptions = [
  { key: 'English', value: 'en' },
  { key: 'Hindi', value: 'hi' },
];
const wcaLanguageOptions = [
  { key: 'English', value: 'en' },
  { key: 'English (US)', value: 'en_US' },
  { key: 'Hindi', value: 'hi' },
  { key: 'Bengali', value: 'bn' },
  { key: 'Bengali (IND)', value: 'bn_IN' },
  { key: 'Gujarati', value: 'gu' },
  { key: 'Kannada', value: 'kn' },
  { key: 'Malayalam', value: 'ml' },
  { key: 'Marathi', value: 'mr' },
  { key: 'Punjabi', value: 'pa' },
  { key: 'Tamil', value: 'ta' },
  { key: 'Telugu', value: 'te' },
  { key: 'Urdu', value: 'ur' },
  { key: 'Afrikaans', value: 'af' },
  { key: 'Albanian', value: 'sq' },
  { key: 'Arabic', value: 'ar' },
  { key: 'Arabic (EGY)', value: 'ar_EG' },
  { key: 'Arabic (UAE)', value: 'ar_AE' },
  { key: 'Arabic (LBN)', value: 'ar_LB' },
  { key: 'Arabic (MAR)', value: 'ar_MA' },
  { key: 'Arabic (QAT)', value: 'ar_QA' },
  { key: 'Azerbaijani', value: 'az' },
  { key: 'Belarusian', value: 'be_BY' },

  { key: 'Bulgarian', value: 'bg' },
  { key: 'Catalan', value: 'ca' },
  { key: 'Chinese (CHN)', value: 'zh_CN' },
  { key: 'Chinese (HKG)', value: 'zh_HK' },
  { key: 'Chinese (TAI)', value: 'zh_TW' },
  { key: 'Croatian', value: 'hr' },
  { key: 'Czech', value: 'cs' },
  { key: 'Danish', value: 'da' },
  { key: 'Dari', value: 'prs_AF' },
  { key: 'Dutch', value: 'nl' },
  { key: 'Dutch (BEL)', value: 'nl_BE' },

  { key: 'English (UK)', value: 'en_GB' },

  { key: 'English (UAE)', value: 'en_AE' },
  { key: 'English (AUS)', value: 'en_AU' },
  { key: 'English (CAN)', value: 'en_CA' },
  { key: 'English (GHA)', value: 'en_GH' },
  { key: 'English (IRL)', value: 'en_IE' },
  { key: 'English (IND)', value: 'en_IN' },
  { key: 'English (JAM)', value: 'en_JM' },
  { key: 'English (MYS)', value: 'en_MY' },
  { key: 'English (NZL)', value: 'en_NZ' },
  { key: 'English (QAT)', value: 'en_QA' },
  { key: 'English (SGP)', value: 'en_SG' },
  { key: 'English (UGA)', value: 'en_UG' },
  { key: 'English (ZAF)', value: 'en_ZA' },
  { key: 'Estonian', value: 'et' },
  { key: 'Filipino', value: 'fil' },
  { key: 'Finnish', value: 'fi' },
  { key: 'French', value: 'fr' },
  { key: 'French (BEL)', value: 'fr_BE' },
  { key: 'French (CAN)', value: 'fr_CA' },
  { key: 'French (CHE)', value: 'fr_CH' },
  { key: 'French (CIV)', value: 'fr_CI' },
  { key: 'French (MAR)', value: 'fr_MA' },
  { key: 'Georgian', value: 'ka' },
  { key: 'German', value: 'de' },
  { key: 'German (AUT)', value: 'de_AT' },
  { key: 'German (CHE)', value: 'de_CH' },
  { key: 'Greek', value: 'el' },
  { key: 'Hausa', value: 'ha' },
  { key: 'Hebrew', value: 'he' },

  { key: 'Hungarian', value: 'hu' },
  { key: 'Indonesian', value: 'id' },
  { key: 'Irish', value: 'ga' },
  { key: 'Italian', value: 'it' },
  { key: 'Japanese', value: 'ja' },
  { key: 'Kazakh', value: 'kk' },
  { key: 'Kinyarwanda', value: 'rw_RW' },
  { key: 'Korean', value: 'ko' },
  { key: 'Kyrgyz (Kyrgyzstan)', value: 'ky_KG' },
  { key: 'Lao', value: 'lo' },
  { key: 'Latvian', value: 'lv' },
  { key: 'Lithuanian', value: 'lt' },
  { key: 'Macedonian', value: 'mk' },
  { key: 'Malay', value: 'ms' },

  { key: 'Norwegian', value: 'nb' },
  { key: 'Pashto', value: 'ps_AF' },
  { key: 'Persian', value: 'fa' },
  { key: 'Polish', value: 'pl' },
  { key: 'Portuguese (BR)', value: 'pt_BR' },
  { key: 'Portuguese (POR)', value: 'pt_PT' },
  { key: 'Romanian', value: 'ro' },

  { key: 'Russian', value: 'ru' },
  { key: 'Serbian', value: 'sr' },
  { key: 'Sinhala', value: 'si_LK' },
  { key: 'Slovak', value: 'sk' },
  { key: 'Slovenian', value: 'sl' },
  { key: 'Spanish', value: 'es' },
  { key: 'Spanish (ARG)', value: 'es_AR' },
  { key: 'Spanish (CHL)', value: 'es_CL' },
  { key: 'Spanish (COL)', value: 'es_CO' },
  { key: 'Spanish (CRI)', value: 'es_CR' },
  { key: 'Spanish (DOM)', value: 'es_DO' },
  { key: 'Spanish (ECU)', value: 'es_EC' },
  { key: 'Spanish (HND)', value: 'es_HN' },
  { key: 'Spanish (MEX)', value: 'es_MX' },
  { key: 'Spanish (PAN)', value: 'es_PA' },
  { key: 'Spanish (PER)', value: 'es_PE' },
  { key: 'Spanish (SPA)', value: 'es_ES' },
  { key: 'Spanish (URY)', value: 'es_UY' },
  { key: 'Swahili', value: 'sw' },
  { key: 'Swedish', value: 'sv' },

  { key: 'Thai', value: 'th' },
  { key: 'Turkish', value: 'tr' },
  { key: 'Ukrainian', value: 'uk' },
  { key: 'Uzbek', value: 'uz' },
  { key: 'Vietnamese', value: 'vi' },
  { key: 'Zulu', value: 'zu' },
];

const templateTypes = [
  { key: 'Text', value: 'TEXT' },
  { key: 'Image', value: 'IMAGE' },
  { key: 'Video', value: 'VIDEO' },
  { key: 'Document', value: 'DOCUMENT' },
];
const headerTypes = [
  { key: 'Text', value: 'TEXT' },
  { key: 'Image', value: 'IMAGE' },
  { key: 'Video', value: 'VIDEO' },
  { key: 'Document', value: 'DOCUMENT' },
];

const wcaHeaderTypes = [
  { key: 'None', value: 'NONE' },
  { key: 'Text', value: 'TEXT' },
  { key: 'Media', value: 'MEDIA' },
  { key: 'Location', value: 'LOCATION' },
];

const buttonTypes = [
  {
    key: 'None',
    value: 'none',
  },

  {
    key: 'Phone Number',
    value: 'PHONE_NUMBER',
  },
  {
    key: 'URL',
    value: 'URL',
  },
  {
    key: 'Quick Reply',
    value: 'QUICK_REPLY',
  },
];

const tempProductButons = [
  {
    id: Math.floor(1000 + Math.random() * 9000),
    text: 'Check',
    type: 'QUICK_REPLY',
    isSaved: true,
  },
  {
    id: Math.floor(1000 + Math.random() * 9000),
    text: 'Not Now',
    type: 'QUICK_REPLY',
    isSaved: true,
  },
];

const quickReplyButtons = [
  {
    id: 1,
    text: 'Interested',
  },
  {
    id: 2,
    text: 'Not Now',
  },
  {
    id: 3,
    text: 'Menu',
  },
  {
    id: 4,
    text: 'Support Agent',
  },
];

const tempCategories = [
  {
    key: 'Marketing',
    value: 'MARKETING',
  },
  {
    key: 'Utility',
    value: 'UTILITY',
  },
  // {
  //   key: "Authentication",
  //   value: "AUTHENTICATION",
  // },
];

const wcaTempCategories = [
  {
    label: 'Promotion',
    value: 'MARKETING',
    description: 'Offers, Campaigns, Product News',
    icon: CampaignIcon,
  },
  {
    label: 'Utility',
    value: 'UTILITY',
    description: 'Order Status, Reminders, Call Requests',
    icon: NotificationIcon,
  },
  {
    label: 'Verification',
    value: 'AUTHENTICATION',
    description: 'OTPs And Security Codes',
    icon: SettingIcon,
  },
];

const wcaMessageType = [
  {
    label: 'Standard',
    value: 'STANDARD',
    description: 'Text message with optional buttons',
  },
  {
    label: 'Carousel',
    value: 'CAROUSEL',
    description: 'Swipable Cards',
  },
  {
    label: 'Products',
    value: 'PRODUCTS',
    description: 'Catalog Products',
  },
];

const templateAboutOptions = [
  {
    key: 'Marketing',
    value: 'Marketing',
  },
  {
    key: 'Welcome Message',
    value: 'Welcome Message',
  },
  {
    key: 'Promotion Announcement',
    value: 'Promotion Announcement',
  },
];
const categoryFilterOptions = [
  'MARKETING',
  'UTILITY',
  //"AUTHENTICATION"
];
const templateFilterOptions = ['Text', 'Image', 'Video', 'Document'];
const templateFilterOptionsWCA = ['TEXT', 'IMAGE', 'VIDEO', 'DOCUMENT', 'LOCATION', 'NONE'];

const templeteVariablesType = {
  '{{customerName}}': 'customerName',
  '{{customerMobile}}': 'customerMobile',
  '{{customerEmail}}': 'customerEmail',
  '{{message}}': 'customNote',
  '{{date}}': 'date',
  '{{time}}': 'time',
  '{{meetingName}}': 'meetingName',
};

const WCAtempleteVariablesType = {
  '{{customername}}': 'customername',
  '{{customermobile}}': 'customermobile',
  '{{customeremail}}': 'customeremail',
  '{{message}}': 'customnote',
  '{{date}}': 'date',
  '{{time}}': 'time',
  '{{meetingname}}': 'meetingname',
};

const formateMessageInput = (message, purpose, variables) => {
  if (message !== undefined) {
    let updatedMessage = message;
    for (let i = 0; i < variables.length; i++) {
      const { variableName, variableValue } = variables[i];
      switch (purpose) {
        case 'preview':
          updatedMessage = updatedMessage.replaceAll(variableName, variableValue);
          break;
        case 'submit':
          updatedMessage = updatedMessage.replaceAll(variableName, `[${variableValue}]`);
          break;
        default:
          updatedMessage = updatedMessage.replace(variableName, `{{${i + 1}}}`);
      }
    }
    return updatedMessage.replace(/\n\s*\n\s*\n/g, '\n\n');
  } else return '';
};

const isVariableExist = (newVar, varsArr) => {
  for (let i = 0; i < varsArr.length; i++) {
    if (varsArr[i].variableName == newVar.variableName) return true;
  }
  return false;
};

const extractVariablesFormMessage = (message) => {
  let variablesArr = [];
  let posibleVariables = [
    'customername',
    'customeremail',
    'customermobile',
    'meetingname',
    'time',
    'date',
    'message',
  ];
  if (message != undefined) {
    message.split('{{').forEach((str) => {
      if (str.includes('}}')) {
        let varStr = str.split('}}')[0];
        let isMessageVar = varStr.includes('message');
        if (posibleVariables.includes(varStr) || isMessageVar) {
          variablesArr.push({
            id: Math.floor(1000 + Math.random() * 9000),
            variableName: `{{${varStr}}}`,
            variableValue: '',
            variableType: isMessageVar ? 'customNote' : varStr, // templeteVariablesType[`{{${varStr}}}`],
          });
        }
      }
    });
  }
  return variablesArr;
};

const formatBodyContent = (message) => {
  console.log('message', message);
  if (message != undefined) {
    let updateContent = message;
    let allVariablesInMessage = extractVariablesFormMessage(message);
    for (let i = 0; i < allVariablesInMessage.length; i++) {
      const { variableName } = allVariablesInMessage[i];
      updateContent = updateContent.replace(variableName, `{{${i + 1}}}`);
    }
    return updateContent.replace(/\n\s*\n\s*\n/g, '\n\n');
  } else return '';
};

const formatVariableArr = (message, sampleVarswithValueArr) => {
  console.log('message, sampleVarswithValueArr', message, sampleVarswithValueArr);
  let formateVarsArr = [];
  if (message != 'undefined') {
    let allVariables = extractVariablesFormMessage(message);
    for (let i = 0; i < allVariables.length; i++) {
      for (let j = 0; j < sampleVarswithValueArr.length; j++) {
        if (allVariables[i].variableName == sampleVarswithValueArr[j].variableName) {
          let tempVar = {
            variableName: `{{${i + 1}}}`,
            variableType: allVariables[i].variableType,
            variableValue: sampleVarswithValueArr[j].variableValue,
          };
          formateVarsArr.push(tempVar);
        }
      }
    }
  }

  return formateVarsArr;
};

const validateMediaSize = (selectedMediaSize, mediaType) => {
  let allowedMediaSize = {
    // image: 1048576 * 3, //1mb = 1048576 bytes
    image: 1048576 * 2, //2mb = 1048576 bytes
    // video: 1048576 * 20, // 20mb = 10485760 bytes,
    video: 1048576 * 4, // 10mb = 10485760 bytes,
    document: 1048576 * 2, //3mb =- 4194304 bytes
  };

  return {
    isValid: selectedMediaSize <= allowedMediaSize[mediaType],
    acceptedSize: allowedMediaSize[mediaType] / 1048576,
  };
};

const blob = async (url) => {
  // return await fetch( url ).then( r => r.blob())
  return await axios.get(url, { responseType: 'blob' }).then((res) => {
    return res.data;
  });
};

const compressImg = async (file) => {
  let maxFileSize = 10e5 / 3;
  const image = await loadImage(file, { orientation: true });
  const compressFactor = Math.sqrt(maxFileSize / file.size) * 0.9;
  const canvas = await loadImage.scale(image.image, {
    maxWidth: image.originalWidth * compressFactor,
    maxHeight: image.originalHeight * compressFactor,
    canvas: true,
  });
  return await new Promise((resolve) => {
    canvas.toBlob((blob) => resolve(new File([blob], file.name, { type: file.type })), file.type);
  });
};
function isValidURL(url) {
  const urlPattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR an IP address
      '(:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(#[-a-z\\d_]*)?$',
    'i',
  );
  return urlPattern.test(url);
}

const refineMessage = (variable, message) => {
  for (let key in variable) {
    if (key) {
      message = message.replace(`${key}`, variable[key]);
    }
  }
  return message;
};

const SPAM_KEYWORDS = [
  'casino',
  'online casino',
  'bet',
  'betting',
  'place your bet',
  'sports betting',
  'real money',
  'win real money',
  'cash out',
  'instant cash',
  'instant withdrawal',
  'fast payout',
  'slots',
  'slot machine',
  'blackjack',
  'roulette',
  'poker',
  'jackpot',
  'mega jackpot',
  'spin to win',
  'free spins',
  'free bet',
  'free chips',
  'no deposit bonus',
  '100% bonus',
  'signup bonus',
  'risk-free bet',
  'double your money',
  'get rich',
  'easy money',
  'quick cash',
  'double your income',
  'exclusive access',
  'you’ve won',
  'claim your prize',
  'click here',
  'act now',
  'limited time offer',
  'don’t miss this',
  'guaranteed win',
  'no risk',
  'money back',
  'winner',
  'massive reward',
  'real cash',
  'earn money now',
  'start winning',
  'win big',
  'play now',
  'play for free',
  'instant prize',
  'massive payout',
  'easy win',
  'jackpot alert',
  'bonus unlocked',
  'spin and win',
];

const SPAM_SUGGESTIONS = {
  'win real money': 'test your luck',
  casino: 'game lounge',
  'free spins': 'bonus rounds',
  'play now': 'enter the game',
  jackpot: 'big prizes',
  bet: 'join the action',
};

const checkForSpam = (text) => {
  const lowerText = text.toLowerCase();
  return SPAM_KEYWORDS.filter((word) => lowerText.includes(word));
};

const TEMPLATE_CONFIG = {
  MARKETING: {
    STANDARD: ['HEADER', 'BODY', 'FOOTER', 'BUTTONS'],
    CAROUSEL: ['BODY', 'CARDS'],
    PRODUCT: ['THUMBNAIL', 'BODY', 'BUTTONS'],
  },

  UTILITY: {
    STANDARD: ['HEADER', 'BODY', 'FOOTER', 'BUTTONS'],
    CALL_PERMISSION: ['BODY', 'BUTTONS'],
  },

  AUTHENTICATION: {
    DEFAULT: ['BODY', 'OTP_SWITCH', 'BUTTONS'],
  },
};

const MESSAGE_TYPE_CONFIG = {
  MARKETING: [
    {
      label: 'Standard',
      value: 'STANDARD',
      description: 'Text message with optional buttons',
    },
    {
      label: 'Carousel',
      value: 'CAROUSEL',
      description: 'Swipable Cards',
    },
    {
      label: 'Products',
      value: 'PRODUCT',
      description: 'Catalog Products',
    },
  ],

  UTILITY: [
    {
      label: 'Standard',
      value: 'STANDARD',
      description: 'Standard notification template',
    },
    {
      label: 'Call Permission',
      value: 'CALL_PERMISSION',
      description: 'Request permission to call user',
    },
  ],

  AUTHENTICATION: [
    {
      label: 'Default',
      value: 'DEFAULT',
      description: 'OTP and authentication messages',
    },
  ],
};

const wcaMediaTypes = [
  { key: 'Image', value: 'IMAGE', icon: 'pi-image', accept: 'image/jpeg,image/png' },
  { key: 'Video', value: 'VIDEO', icon: 'pi-video', accept: 'video/mp4' },
  { key: 'Document', value: 'DOCUMENT', icon: 'pi-file', accept: '.doc,.docx,.pdf' },
  { key: 'Gif', value: 'GIF', icon: 'pi-image', accept: 'image/gif' },
];

const BUTTON_LIMITS = {
  MARKETING: {
    maxTotal: 10,
    maxCTA: 3,
    maxURL: 2,
    maxPhone: 1,
    maxQuickReply: 10,
  },

  CAROUSEL: {
    maxTotal: 2,
    maxCTA: 2,
    maxURL: 2,
    maxPhone: 1,
    maxQuickReply: 2,
  },
};

const formatWCAMessage = (message, purpose, variables) => {
  if (!message) return '';

  let updatedMessage = message;

  variables.forEach(({ variableName, variableValue }) => {
    if (purpose === 'preview') {
      updatedMessage = updatedMessage.replaceAll(variableName, variableValue);
    }

    if (purpose === 'submit') {
      updatedMessage = updatedMessage.replaceAll(
        variableName,
        `{{${variableName.replace(/[{}]/g, '')?.toLowerCase()}}}`,
      );
    }
  });

  return updatedMessage.replace(/\n\s*\n\s*\n/g, '\n\n');
};

const buildWCAHeaderComponent = async (data, dispatch, metadataId) => {
  const { headerType, header, file, mediaType } = data;

  // ❌ No header
  if (!headerType || headerType === 'NONE') return null;

  // ✅ TEXT HEADER
  if (headerType === 'TEXT') {
    return {
      type: 'HEADER',
      format: 'TEXT',
      text: header || '',
    };
  }
  // ✅ LOCATION Location
  if (headerType === 'LOCATION') {
    return {
      type: 'HEADER',
      format: 'LOCATION',
    };
  }

  // ✅ MEDIA HEADER
  if (headerType === 'MEDIA' && mediaType) {
    if (!file) {
      console.log('❌ File missing');
      return null;
    }

    try {
      console.log('🚀 Uploading file...');

      const uploadRes = await dispatch(
        wcaUploadProfilePicture({
          metadataid: metadataId,
          file,
        }),
      ).unwrap();

      const handle = uploadRes?.h;

      console.log('✅ Upload success', handle);

      return {
        type: 'HEADER',
        format: mediaType, // IMAGE / VIDEO / DOCUMENT
        example: {
          header_handle: [handle],
        },
      };
    } catch (err) {
      console.error('❌ Upload failed', err);
      return null;
    }
  }

  return null;
};

const buildWCABodyComponent = (content, variables) => {
  console.log('variables', variables);
  console.log('variables', variables.length);
  return {
    type: 'BODY',
    text: formatWCAMessage(content, 'submit', variables),
    ...(variables.length > 0 && {
      example: {
        body_text_named_params: variables.map((v) => ({
          param_name: v.variableName.replace(/[{}]/g, '')?.toLowerCase(),
          example: v.variableValue || 'sample',
        })),
      },
    }),
  };
};
const buildWCAFooterComponent = (footer) => {
  if (!footer) return null;

  return {
    type: 'FOOTER',
    text: footer,
  };
};
const buildWCAButtonsComponent = (templateButtons) => {
  if (!templateButtons?.length) return null;

  return {
    type: 'BUTTONS',
    buttons: templateButtons
      .map((btn) => {
        switch (btn.type) {
          case 'QUICK_REPLY':
            return {
              type: 'QUICK_REPLY',
              text: btn.text,
            };

          case 'URL':
            return {
              type: 'URL',
              text: btn.text,
              url: btn.url,
            };

          case 'PHONE_NUMBER':
            return {
              type: 'PHONE_NUMBER',
              text: btn.text,
              phone_number: btn.phone_number,
            };

          default:
            return null;
        }
      })
      .filter(Boolean),
  };
};

const buildWCAMediaCarouselComponent = async (cards, dispatch, metadataId) => {
  const formattedCards = await Promise.all(
    cards.map(async (card) => {
      const { mediaType, media, buttons } = card;

      // ✅ Upload media
      let handle = null;

      if (media) {
        try {
          const uploadRes = await dispatch(
            wcaUploadProfilePicture({
              metadataid: metadataId,
              file: media,
            }),
          ).unwrap();

          handle = uploadRes?.h;
        } catch (err) {
          console.error('❌ Carousel media upload failed', err);
        }
      }

      // ✅ Header Component (per card)
      const headerComponent =
        handle && mediaType
          ? {
              type: 'header',
              format: mediaType,
              example: {
                header_handle: [handle],
              },
            }
          : null;

      // ✅ Buttons Component (per card)
      const buttonsComponent =
        buttons?.length > 0
          ? {
              type: 'buttons',
              buttons: buttons
                .map((btn) => {
                  switch (btn.type) {
                    case 'QUICK_REPLY':
                      return {
                        type: 'QUICK_REPLY',
                        text: btn.text,
                      };

                    case 'URL':
                      return {
                        type: 'URL',
                        text: btn.text,
                        url: btn.url,
                        ...(btn.url?.includes('{{') && {
                          example: [btn.url],
                        }),
                      };

                    case 'PHONE_NUMBER':
                      return {
                        type: 'PHONE_NUMBER',
                        text: btn.text,
                        phone_number: btn.phone_number,
                      };

                    default:
                      return null;
                  }
                })
                .filter(Boolean),
            }
          : null;

      return {
        components: [headerComponent, buttonsComponent].filter(Boolean),
      };
    }),
  );

  return {
    type: 'carousel',
    cards: formattedCards,
  };
};
const buildWCAProductCarouselComponent = (cards, ctaType, productCTA) => {
  const formattedCards = cards.map(() => {
    // ✅ Header (always product)
    const headerComponent = {
      type: 'header',
      format: 'product',
    };

    // ✅ Buttons
    let buttons = [];

    if (ctaType === 'VIEW') {
      buttons.push({
        type: 'spm',
        text: 'View',
      });
    }

    if (ctaType === 'CUSTOM') {
      buttons.push({
        type: 'url',
        text: productCTA?.text || 'Visit',
        url: productCTA?.url || '',
        ...(productCTA?.url?.includes('{{') && {
          example: [productCTA.url],
        }),
      });
    }

    return {
      components: [
        headerComponent,
        {
          type: 'buttons',
          buttons,
        },
      ],
    };
  });

  return {
    type: 'carousel',
    cards: formattedCards,
  };
};

const buildWCAProductComponent = (data, variables) => {
  const { productType, content, footer } = data;

  const bodyComponent = buildWCABodyComponent(content, variables);

  // 🟢 CATALOG
  if (productType === 'CATALOG') {
    return [
      bodyComponent,
      {
        type: 'BUTTONS',
        buttons: [
          {
            type: 'CATALOG',
            text: 'View catalog',
          },
        ],
      },
    ];
  }

  // 🟢 MULTI PRODUCT
  if (productType === 'MULTI') {
    return [
      bodyComponent,
      {
        type: 'BUTTONS',
        buttons: [
          {
            type: 'MPM',
            text: 'View items',
          },
        ],
      },
    ];
  }

  // 🟢 SINGLE PRODUCT
  if (productType === 'SINGLE') {
    return [
      {
        type: 'HEADER',
        format: 'product',
      },
      bodyComponent,
      ...(footer
        ? [
            {
              type: 'FOOTER',
              text: footer,
            },
          ]
        : []),
      {
        type: 'BUTTONS',
        buttons: [
          {
            type: 'spm',
            text: 'View',
          },
        ],
      },
    ];
  }

  return [];
};
const buildWCAAuthenticationComponent = (data) => {
  const { securityDisclaimer, expirationWarning, authCTA } = data;

  const components = [
    {
      type: 'BUTTONS',
      buttons: [
        {
          type: 'OTP',
          otp_type: 'COPY_CODE',
        },
      ],
    },
  ];

  // ✅ BODY (Security Disclaimer)
  if (securityDisclaimer) {
    components.push({
      type: 'BODY',
      add_security_recommendation: true,
    });
  }

  // ✅ FOOTER (Expiration)
  if (expirationWarning) {
    components.push({
      type: 'FOOTER',
      code_expiration_minutes: 10, // 🔥 you can make this dynamic later
    });
  }

  return components;
};

// utils/templatePreviewParser.js

const parseTemplateToPreview = (template) => {
  if (!template?.components) {
    return {
      header: '',
      content: '',
      footer: '',
      buttons: [],
      media: null,
    };
  }

  let header = '';
  let content = '';
  let footer = '';
  let buttons = [];
  let media = {
    image: null,
    video: null,
    document: null,
  };

  template.components.forEach((comp) => {
    switch (comp.type) {
      case 'BODY':
        content = comp.text || '';
        break;

      case 'HEADER':
        if (comp.format === 'TEXT') {
          header = comp.text || '';
        }

        // ✅ Media handling (use example URL directly)
        if (comp.format === 'IMAGE') {
          media.image = comp?.example?.header_handle?.[0] || null;
        }

        if (comp.format === 'VIDEO') {
          media.video = comp?.example?.header_handle?.[0] || null;
        }

        if (comp.format === 'DOCUMENT') {
          media.document = comp?.example?.header_handle?.[0] || null;
        }

        break;

      case 'FOOTER':
        footer = comp.text || '';
        break;

      case 'BUTTONS':
        buttons = comp.buttons || [];
        break;

      case 'CAROUSEL':
        // Optional (basic handling)
        buttons =
          comp.cards?.flatMap((card) => {
            const btnComp = card.components?.find((c) => c.type === 'BUTTONS');
            return btnComp?.buttons || [];
          }) || [];
        break;

      default:
        break;
    }
  });

  return {
    header,
    content,
    footer,
    buttons,
    media,
  };
};

export {
  validateMediaSize,
  formateMessageInput,
  extractVariablesFormMessage,
  formatBodyContent,
  blob,
  compressImg,
  categoryFilterOptions,
  templateFilterOptions,
  templateFilterOptionsWCA,
  languageOptions,
  wcaLanguageOptions,
  tempCategories,
  wcaTempCategories,
  buttonTypes,
  templateTypes,
  headerTypes,
  wcaHeaderTypes,
  templeteVariablesType,
  WCAtempleteVariablesType,
  quickReplyButtons,
  tempProductButons,
  templateAboutOptions,
  isVariableExist,
  formatVariableArr,
  isValidURL,
  refineMessage,
  SPAM_KEYWORDS,
  SPAM_SUGGESTIONS,
  checkForSpam,
  wcaMessageType,
  TEMPLATE_CONFIG,
  MESSAGE_TYPE_CONFIG,
  wcaMediaTypes,
  BUTTON_LIMITS,
  formatWCAMessage,
  buildWCAHeaderComponent,
  buildWCABodyComponent,
  buildWCAFooterComponent,
  buildWCAButtonsComponent,
  buildWCAMediaCarouselComponent,
  buildWCAProductCarouselComponent,
  buildWCAProductComponent,
  buildWCAAuthenticationComponent,
  parseTemplateToPreview,
};
